export const RENDERINGS_BASE = 'https://designwithfriends.com/renderings';
